import React, { Component } from 'react'
import './index.css'
import withRouter from '../../withRouter'
import PageRoute from '../PageRoute'
import axios from 'axios'
import serverInfo from "../../config.js"
import PubSub from 'pubsub-js'
 class RMAPage extends Component {
    constructor(props){
        super(props)
        this.fullNameRef = React.createRef()
        this.phoneRef = React.createRef()
        this.emailRef = React.createRef()
        this.orderNumberRef = React.createRef()
        this.companyRef = React.createRef()
        this.addressRef = React.createRef()
        this.itemModelRef = React.createRef()
        this.quantityRef = React.createRef()
        this.serialNumberRef = React.createRef()
        this.purchaseDateRef = React.createRef()
        this.questionRef = React.createRef()
        this.state={
            fullNameCheck:true,
            phoneCheck:true,
            emailCheck:true,
            orderNumberCheck:true,
            companyChcek:true,
            addressCheck:true,
            itemModelCheck:true,
            quantityCheck:true,
            serialNumberCheck:true,
            purchaseDateCheck:true,
            questionCheck:true,
            questionContent:null,
            section:'chart'
        }
    }
    submitForm = (e) =>{
        e.preventDefault()
        const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
        const phoneRegex = /^\d{10}$/
        const fullNameCheck = this.dataFormCheck(this.fullNameRef.current.value,true,50)
        const phoneCheck= phoneRegex.exec(this.phoneRef.current.value) ? true : false
        const emailCheck= emailRegex.exec(this.emailRef.current.value) ? true : false
        const orderNumberCheck = this.dataFormCheck(this.orderNumberRef.current.value,true,50)
        const companyChcek = this.dataFormCheck(this.companyRef.current.value,false,50)
        const addressCheck = this.dataFormCheck(this.addressRef.current.value,true,500)
        const itemModelCheck = this.dataFormCheck(this.itemModelRef.current.value,true,50)
        const quantityCheck = this.dataFormCheck(this.quantityRef.current.value,true,50)
        const serialNumberCheck = this.dataFormCheck(this.serialNumberRef.current.value,true,500)
        const purchaseDateCheck = this.dataFormCheck(this.purchaseDateRef.current.value,true,50) && this.purchaseDateRef.current.value!==''
        const questionCheck = this.dataFormCheck(this.state.questionContent,true,5000)
        this.setState({fullNameCheck,phoneCheck,emailCheck,orderNumberCheck,companyChcek,addressCheck,itemModelCheck,quantityCheck,serialNumberCheck,purchaseDateCheck,questionCheck})
        if(fullNameCheck&&phoneCheck&&emailCheck&&orderNumberCheck&&companyChcek&&addressCheck&&itemModelCheck&&quantityCheck&&serialNumberCheck&&purchaseDateCheck&&questionCheck){
            const data = {
                fullName:this.fullNameRef.current.value,
                phoneNumber:this.phoneRef.current.value,
                email:this.emailRef.current.value,
                orderNumber:this.orderNumberRef.current.value,
                company:this.companyRef.current.value,
                address:this.addressRef.current.value,
                itemModel:this.itemModelRef.current.value,
                quantity:this.quantityRef.current.value,
                serialNumber:this.serialNumberRef.current.value,
                purchaseDate:this.purchaseDateRef.current.value,
                questions:this.state.questionContent
            }
            // console.log(data)
            // this.setState({section:'sent'})
            // window.scrollTo({top:0,behavior:"auto"})
            axios.post(`${serverInfo.baseURL}/zoho/sendrma`,data,{headers:{'customerid':serverInfo.customerid,'authorization':serverInfo.token}}).then(
                res=>{
                    if(res.data.scode === 200){
                        this.setState({section:'sent'})
                        window.scrollTo({top:0,behavior:"auto"})
                    }else{
                        alert(res.data.smessage)
                    }
                },
                rej=>console.log(rej)
            )
        }
        // this.setState({section:'sent'})
        // window.scrollTo({top:0,behavior:"auto"})
        // console.log(serialNumberCheck)
    }
    dataFormCheck = (value,isMandatory,maxLength) =>{
        if(isMandatory){
            return (!value || value === "" || value.length > maxLength) ? false : true
        }else{
            return (!value?.length || value?.length <= maxLength) ? true : false
        }
    }
    componentDidMount(){
        window.scrollTo({top:0,behavior:"auto"})
        PubSub.publish('routes',[
            {pathname:'/acer/rma',name:"RMA",isCurrent:true},
        ])
    }
  render() {
    return (
      <div className='contactpage'>
        <PageRoute/>
        <div className='contactpage-content' style={{display:this.state.section ==='chart'?"flex":"none"}}>
            <h1>RMA Request</h1>
            <p>We're happy to answer questions or help you with returns. </p>
            <p>Please fill out the form below if you need assistance.</p>
            <p style={{fontSize:"14px"}}>We are available <b>Monday</b> through <b>Friday</b> from <b>9AM</b> to <b>5PM</b> EST.  If your call is urgent, please contact us at <b>1-905-731-1928</b>.</p>
            <form action="">
                <div>
                    <p>
                        <label className='mandatory'>Full Name</label>
                        <input type='text' ref={this.fullNameRef} className={this.state.fullNameCheck?"":"error"} maxLength={50}/>
                        <label className={this.state.fullNameCheck?"":"error"} style={{display:this.state.fullNameCheck?"none":""}}>Full name cannot be empty, max length is 50.</label>
                    </p>
                    <p>
                        <label className='mandatory'>Phone Number</label>
                        <input ref={this.phoneRef} type='text' className={this.state.phoneCheck?"":"error"} maxLength={10}/>
                        <label className={this.state.phoneCheck?"":"error"} style={{display:this.state.phoneCheck?"none":""}}> Please enter 10 digits number without any other characters.</label>
                    </p>
                </div>
                <div>
                    <p>
                        <label className='mandatory'>Email Address</label>
                        <input ref={this.emailRef} type='text' className={this.state.emailCheck?"":"error"} maxLength={50}/>
                        <label className={this.state.emailCheck?"":"error"} style={{display:this.state.emailCheck?"none":""}}>Email address format is wrong, max length is 50.</label>
                    </p>
                    <p>
                        <label className='mandatory'>Order Number</label>
                        <input ref={this.orderNumberRef} type='text' className={this.state.orderNumberCheck?"":"error"} maxLength={50}/>
                        <label className={this.state.orderNumberCheck?"":"error"} style={{display:this.state.orderNumberCheck?"none":""}}>Order number be empty or exceed max length 50.</label>
                    </p>
                </div>
                <div>
                    <p>
                        <label>Company Name</label>
                        <input ref={this.companyRef} type='text' className={this.state.companyChcek?"":"error"} maxLength={50}/>
                        <label className={this.state.companyChcek?"":"error"} style={{display:this.state.companyChcek?"none":""}}>Company name cannot exceed max length 50.</label>
                    </p>
                    <p>
                        <label className='mandatory'>Address</label>
                        <input ref={this.addressRef} type='text' className={this.state.addressCheck?"":"error"} maxLength={500}/>
                        <label className={this.state.addressCheck?"":"error"} style={{display:this.state.addressCheck?"none":""}}>Address cannot be empty or exceed max length 500.</label>
                    </p>
                </div>
                <div>
                    <p>
                        <label className='mandatory'>Item Model</label>
                        <input ref={this.itemModelRef} type='text' className={this.state.itemModelCheck?"":"error"} maxLength={50}/>
                        <label className={this.state.itemModelCheck?"":"error"} style={{display:this.state.itemModelCheck?"none":""}}>Item Model cannot be empty or exceed max length 50.</label>
                    </p>
                    <p>
                        <label className='mandatory'>Quantity</label>
                        <input ref={this.quantityRef} type='number' className={this.state.quantityCheck?"":"error"} maxLength={50}/>
                        <label className={this.state.quantityCheck?"":"error"} style={{display:this.state.quantityCheck?"none":""}}>Quantity cannot cannot be empty.</label>
                    </p>
                </div>
                <div>
                    <p>
                        <label className='mandatory'>Serial Number</label>
                        <input ref={this.serialNumberRef} type='text' className={this.state.serialNumberCheck?"":"error"} maxLength={500}/>
                        <label className={this.state.serialNumberCheck?"":"error"} style={{display:this.state.serialNumberCheck?"none":""}}>Serial Number cannot be empty or exceed max length 500.</label>
                    </p>
                    <p>
                        <label className='mandatory'>Purchase Date</label>
                        <input ref={this.purchaseDateRef} type='date' className={this.state.purchaseDateCheck?"":"error"} maxLength={50}/>
                        <label className={this.state.purchaseDateCheck?"":"error"} style={{display:this.state.purchaseDateCheck?"none":""}}>Purchase Date cannot be empty.</label>
                    </p>
                </div>
                <p className='contactpage-question'>
                    <label className='mandatory'>Comments/Questions</label>
                    <label className={this.state.questionCheck?"":"error"} style={{display:this.state.questionCheck?"none":""}}>Quesitons cannot be empty, max length is 5000.</label>
                    <textarea onChange={(e)=>{this.setState({questionContent:e.target.value})}} maxLength={5000}></textarea>
                    
                </p>
                <div className='contactpage-submit'>
                    <button onClick={(e)=>this.submitForm(e)}>SUBMIT FORM</button>
                </div>
            </form>
        </div>
        <div className='contactpage-content' style={{display:this.state.section ==='sent'?"flex":"none"}}>
            <h1>RMA Request</h1>
            <h2 style={{width:'100%',textAlign:'center'}}>Your RMA Request has been sent, we will reply you within few days.</h2>
        </div>
      </div>
    )
  }
}
export default withRouter(RMAPage)